import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepGroupParticipantsFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepGroupParticipantsFormContainer.jsx';

const EditProfileStepGroupParticipants = ({
  projectId,
  stakeholderId,
  slug,
}) => (
  <>
    <Helmet>
      <title>Edit Stakeholder | ChangeSync</title>
    </Helmet>
    <StepGroupParticipantsFormContainer
      projectId={projectId}
      stakeholderId={stakeholderId}
      slug={slug}
    />
  </>
);

EditProfileStepGroupParticipants.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  stakeholderId: Number(query.stakeholderId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditProfileStepGroupParticipants));
